import React, { useState, useEffect } from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@mui/styles";

const BORDER_GREY = "#e8e8e8";
const WHITE = "#ffffff";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
    marginTop: "-8px",
  },
  paper: {
    padding: "13px 17px",
    zIndex: "999",
    fontWeight: "500",
    fontSize: "14px",
    position: "absolute",
    marginLeft: "13px",
    filter: "drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1))",
    boxShadow: "none",
    overflow: "visible",
    borderRadius: "8px",
    border: `1px solid ${BORDER_GREY}`,
    "&:before": {
      backgroundColor: WHITE,
      content: '""',
      display: "block",
      position: "absolute",
      width: 16,
      height: 16,
      borderRadius: "2px",
      left: "-9px",
      transform: "rotate(45deg)",
      top: "15px",
      borderLeft: `2px solid ${BORDER_GREY}`,
      borderBottom: `2px solid ${BORDER_GREY}`,
    },
  },
}));

const PopoverMui = ({ title, children, visible, triggerOnClick }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const currentPath = window.location.pathname;

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClick = (event) => {
    if (open) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (open) {
      setAnchorEl(null);
    }
  }, [currentPath]);

  return (
    <>
      {triggerOnClick ? (
        <div aria-haspopup="true" aria-describedby={id} onClick={handleClick}>
          {children}
        </div>
      ) : (
        <div
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handleClose}
        >
          {children}
        </div>
      )}

      <Popover
        id={triggerOnClick ? id : "mouse-over-popover"}
        disableScrollLock
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open && visible}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableRestoreFocus
      >
        <div dangerouslySetInnerHTML={{ __html: title }} />
      </Popover>
    </>
  );
};

export default PopoverMui;
